import ItemEditor from "../components/ItemEditor";

const ItemEditPage = () => <ItemEditor />;

export default ItemEditPage;
